/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
import { objectToMap } from "../../util/index.js";
// TODO: test + document
export function objectToMapTyped(objectMap) {
    return objectToMap(objectMap);
}
//# sourceMappingURL=typeUtils.js.map